var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "portfolios-comparisons-view" } },
    [
      _c(
        "portal",
        { attrs: { to: "ads-container-top" } },
        [
          _c("ci-suggested-external-content", {
            attrs: { id: _vm.adIds.header, type: "display" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "ads-container-right" } },
        [
          _c("ci-suggested-external-content", {
            attrs: { id: _vm.adIds.skyscraper, type: "skyscraper" },
          }),
          _vm._v(" "),
          _c("ci-suggested-external-content", {
            attrs: { id: _vm.adIds.sidebar_2nd, type: "sidebar" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ais-instant-search",
        {
          ref: "instantSearch",
          attrs: {
            "search-client": _vm.searchClient,
            "index-name": _vm.indexName,
            "search-function": _vm.searchFunction,
            routing: _vm.routing,
            future: { preserveSharedStateOnUnmount: true },
          },
        },
        [
          _c("ais-configure", {
            attrs: {
              hitsPerPage: _vm.searchConfig.hitsPerPage,
              filters: _vm.searchConfig.filters,
              typoTolerance: "min",
            },
          }),
          _vm._v(" "),
          _c("div", { attrs: { id: "portfolios-comparisons-view__header" } }, [
            _c(
              "div",
              { staticClass: "ci-content-header__inner bg-white" },
              [
                _c("h2", {
                  staticClass: "h2 row m-0",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.views.portfolios.comparisons.header.title")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "ui.views.portfolios.comparisons.header.description"
                      )
                    ),
                  },
                }),
                _vm._v(" "),
                _c("ci-button", {
                  staticClass: "d-block d-md-none w-100",
                  attrs: {
                    label: _vm.$t(
                      "ui.components.portfolios.comparisons.filter_and_sorting_label"
                    ),
                    variant: "filled-primary",
                    icon: "mdi-filter",
                  },
                  on: { click: _vm.handleFiltersMenu },
                }),
                _vm._v(" "),
                _c("ci-portfolios-comparison-filters", {
                  ref: "filters",
                  attrs: {
                    "selected-performance-interval":
                      _vm.selectedPerformanceInterval,
                  },
                  on: {
                    "sorting-changed": _vm.handleSortingChanged,
                    "reset-filters": _vm.handleResetFilters,
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "current-filters d-flex align-items-center mt-3",
                  },
                  [
                    _c("ais-current-refinements", {
                      attrs: {
                        "transform-items": _vm.transformCurrentRefinements,
                      },
                    }),
                    _vm._v(" "),
                    _c("ci-clear-refinements", {
                      attrs: { variant: "visibility" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-mw ci-content__body p-3 p-md-4" },
            [
              _c("ais-hits", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ items }) {
                      return [
                        items.length > 0
                          ? [
                              _c("ais-stats", {
                                staticClass: "row m-0 align-items-center",
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ nbHits }) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "col-6 p-0" },
                                            [
                                              _c("h4", {
                                                staticClass: "h4 mb-0",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "ui.views.portfolios.comparisons.results",
                                                      { hints: nbHits }
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "performance-years col-6 d-flex p-0",
                                            },
                                            [
                                              _vm.mobileMode
                                                ? [
                                                    _c(
                                                      "ci-dropdown-menu",
                                                      {
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "button-content",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "active d-inline",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                          " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              _vm
                                                                                .selectedPerformanceInterval
                                                                                .label,
                                                                              {
                                                                                period:
                                                                                  _vm
                                                                                    .selectedPerformanceInterval
                                                                                    .period,
                                                                              }
                                                                            )
                                                                          ) +
                                                                          "\n                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "mdi mdi-24px mdi-menu-down d-inline",
                                                                  }),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.performanceIntervals,
                                                          function (interval) {
                                                            return _c(
                                                              "ci-dropdown-menu-item",
                                                              {
                                                                key: interval.performance_key,
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.intervalClass(
                                                                      interval
                                                                    ) ==
                                                                    "disabled",
                                                                  "item-name-class":
                                                                    _vm.intervalClass(
                                                                      interval
                                                                    ),
                                                                  name: _vm.$t(
                                                                    interval.label,
                                                                    {
                                                                      period:
                                                                        interval.period,
                                                                    }
                                                                  ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handlePerformanceIntervalSelected(
                                                                        interval
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                : _vm._l(
                                                    _vm.performanceIntervals,
                                                    function (interval, index) {
                                                      return [
                                                        _c("p", {
                                                          key: interval.performance_key,
                                                          staticClass:
                                                            "interval m-0",
                                                          class:
                                                            _vm.intervalClass(
                                                              interval
                                                            ),
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.$t(
                                                                interval.label,
                                                                {
                                                                  period:
                                                                    interval.period,
                                                                }
                                                              )
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handlePerformanceIntervalSelected(
                                                                interval
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        index !==
                                                        _vm.performanceIntervals
                                                          .length -
                                                          1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                key: `S${index}`,
                                                                staticClass:
                                                                  "separator px-2 m-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      |\n                    "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    }
                                                  ),
                                            ],
                                            2
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _vm._l(items, function (portfolio) {
                                return _c(
                                  "div",
                                  {
                                    key: portfolio.id,
                                    staticClass: "row m-0 mt-2",
                                  },
                                  [
                                    _c("ci-portfolio-comparison-tile", {
                                      staticClass: "mb-0 w-100",
                                      attrs: {
                                        portfolio: portfolio,
                                        "performance-interval":
                                          _vm.selectedPerformanceInterval,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mt-3 mt-md-4",
                                },
                                [
                                  _c("ais-pagination", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({
                                            currentRefinement,
                                            nbPages,
                                            pages,
                                            refine,
                                          }) {
                                            return [
                                              _c("ci-pagination", {
                                                attrs: {
                                                  "current-page":
                                                    currentRefinement,
                                                  "number-of-pages": nbPages,
                                                  pages: pages,
                                                  callback: refine,
                                                  "on-switch":
                                                    _vm.onPaginationChange,
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          : [
                              _c("ci-emptystate", {
                                staticClass: "ci-card",
                                attrs: { search: true },
                              }),
                            ],
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }